<!--
 * @Author: your name
 * @Date: 2020-11-12 09:23:31
 * @LastEditTime: 2020-11-23 20:38:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/themelist/components/ThemeProduct/index.vue
-->
<template>
  <!-- 清单商品列表 -->
  <div class="theme_list text_left" @click="goDetail(product.id)">
    <img :src="product.spuImg" alt="" class="product_img" />
    <div class="product_right">
      <div class="p_name font_weight400 font12 line_height_17 colo087">
        {{ product.name }}
      </div>
      <div class="p_con">
        <tags :tradeType="product.tradeType" :includeTax="product.includeTax" />
        <div class="font_weight600 font16 line_height_19 colo087">
          {{ product.storePrice | currency(false) }}
        </div>
      </div>
      <!-- <div class="font_weight400 font10 line_height_14 colo055">
        销量：{{ product.salesVolume }}
      </div> -->
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  props: {
    product: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    Tags
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      this.$emit("goDetail", id);
    }
  }
};
</script>

<style lang="less" scoped>
.theme_list {
  background: #fff;
  border-radius: 12px;
  margin: 0 12px 12px;
  display: flex;
  justify-content: flex-start;
  padding: 12px;
  .product_img {
    width: 96px;
    height: 96px;
    background: #f6f7f8;
    border-radius: 6px;
    margin-right: 12px;
  }
  .product_right {
    width: 100%;
    .p_name {
      margin-top: 12px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .p_con {
      display: flex;
      justify-content: space-between;
      margin: 5px 0 4px;
    }
  }
}
</style>
